import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import moment from 'moment'
import ActionHistory from '../../Components/ActionHistory'
import appointmentActions from '../../Actions/appointmentActions'
import SendEmailModal from '../Appointment/AppointmentSendEmailModal'
import CloseModal from '../Appointment/AppointmentCloseModal'
import BuyModal from '../Appointment/AppointmentBuyModal'
import AppointmentDetailActions from '../../Components/Appointment/AppointmentDetailActions'
import AppointmentFormContainer from '../Appointment/AppointmentFormContainer'
import {useParams, useNavigate } from 'react-router-dom';
import {withTranslation} from "react-i18next";
import customerRoutes from "../../Constants/Customer/customerRoutes";
import { CardContainer, CardRow, DefaultCard } from "../../Components/Card/Card";
import { FormInput } from "../../Components/FormComponents/Input/Input";

function CustomerAppointmentFormContainer({ appointmentActions, customer, user, appointment, t }) {

    const {appointmentId} = useParams();
    const navigate = useNavigate();
    const [activeModal, setActiveModal] = useState();
    const [emailActionLogId, setEmailActionLogId] = useState(0)

    useEffect(() => {
        appointmentId
            ? appointmentActions.editAppointment(appointmentId)
            : appointmentActions.addAppointment('appointmentForm', createAppointmentFormData())

        return () => {
            appointmentActions.clearAppointment();
        }
    }, [])

    const createAppointmentFormData = () => {

        return {
            customerNumber: customer.vbCustomer?.customerNumber,
            customerName: customer.name,
            contactPerson: customer.contactPerson.fullName,
            phoneNumber: customer.contactPerson.phoneNumber,
            emailAddress: customer.contactPerson.email,
            time: moment().format('YYYY-MM-DD HH:mm'),
            assigneeName: user.name,
            assignee: user.email,
            subject: "",
            comments: ""
        }
    }

    const toggleModal = (modalName, emailActionLogId = 0) => {
        setActiveModal(modalName)

        setEmailActionLogId(emailActionLogId)
    }

    const onNoAnswerClick = () => {
        var payload = {data: {action: "No answer"}};

        appointmentActions.saveAction(appointment.id, payload, false);
        refresh();

    }

    const onCloseClick = (isModal) => {

        if (isModal) {
            navigate(customerRoutes.customer(customer.pathId, customerRoutes.Appointments));
        } else {
            if (location.useGoBack) {
                navigate(-1)
            } else {
                navigate(customerRoutes.customer(customer.pathId, customerRoutes.Appointments))
            }
        }
    }

    const onBuyClick = (actionName) => {
        if (actionName === 'order') {
            navigate(customerRoutes.customer(customer.pathId, customerRoutes.orderPlacement))
        } else if (actionName === 'close') {
            toggleModal("showBuyModal");
        }
    }

    const refresh = () => {
        appointmentActions.editAppointment(appointment.id);
    }

    const navigateAfterAction = () => {
        return () => navigate(customerRoutes.customer(customer.pathId, customerRoutes.Appointments));
    }


    const isCreation = !appointmentId;

    const isCompleted = (appointment && appointment.isCompleted) || false;

    let leadType = "";
    if (appointment)
        leadType = appointment.lead && appointment.lead.isAoLead ? "aoLead" : "lead";

    return (
        <CardContainer title={t('appointmentscontainer.headernew')}>
            {activeModal === "showSendEmailModal" &&
                <SendEmailModal onClose={toggleModal.bind(this, "showSendEmailModal")} onSave={() => onCloseClick(true)}
                                emailActionLogId={emailActionLogId}/>}
            {activeModal === "showCloseModal" &&
                <CloseModal leadType={leadType} onClose={toggleModal.bind(this, "showCloseModal")}
                            onSave={() => onCloseClick(true)} callback={navigateAfterAction()}/>}
            {activeModal === "showBuyModal" &&
                <BuyModal leadType={leadType} onClose={toggleModal.bind(this, "showBuyModal")}
                          onSave={() => onCloseClick(true)} callback={navigateAfterAction()}/>}


            <CardRow orientation={"horizontal"}>
                <DefaultCard title={t('appointmentscontainer.headernew')}>
                    <AppointmentFormContainer callback={navigateAfterAction()} isCreation={!appointmentId}
                                              isMyAppointment={false} appointmentFormWidth={12}/>
                </DefaultCard>
                <React.Fragment>

                    {!isCreation && !isCompleted && <>
                        <AppointmentDetailActions
                            leadType={leadType}
                            onClick={(modalId) => toggleModal(modalId)}
                            onNoAnswerClick={() => onNoAnswerClick()}
                            onBuyClick={onBuyClick}
                            hasCustomer={appointment && !!appointment.customerNumber}
                        /><br/>
                    </> }

                    <DefaultCard title={customer.name}>
                        <FormInput label={t('common.customernumber')} value={customer.vbCustomer.customerNumber} readOnly={true} />
                        <FormInput label={t('common.contactperson')} value={customer.contactPerson.fullName} readOnly={true} />
                        <FormInput label={t('common.email')} value={customer.contactPerson.email} readOnly={true} />
                        <FormInput label={t('common.organizationnumber')} value={customer.vbCustomer.organizationNumber} readOnly={true} />
                    </DefaultCard>
                    <br/>
                    <ActionHistory actionHistory={appointment?.actionHistory}
                                   toggleModal={(modalId, emailActionLogId) => toggleModal(modalId, emailActionLogId)}/>
                </React.Fragment>
            </CardRow>
        </CardContainer>
    );
}


function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        user: state.CommonReducer.user,
        appointment: state.AppointmentReducer.appointment
    }
}

function mapDispatchToProps(dispatch) {
    return {
        appointmentActions: bindActionCreators(appointmentActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomerAppointmentFormContainer));